import { render, staticRenderFns } from "./PrimaryDiagnosis.vue?vue&type=template&id=3fe67792"
import script from "./PrimaryDiagnosis.vue?vue&type=script&lang=js"
export * from "./PrimaryDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./PrimaryDiagnosis.vue?vue&type=style&index=0&id=3fe67792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports